import { Pipe, PipeTransform } from '@angular/core';
import { AngleMode } from '../models/cutting/cutting-panel-outline.model';

@Pipe({
  name: 'angleProcessingName',
})
export class AngleProcessingNamePipe implements PipeTransform {
  transform(value: AngleMode, noneName = ''): string {
    switch (value) {
      case AngleMode.None:
        return noneName;

      case AngleMode.Rounded:
        return $localize`Наружный радиус`;

      case AngleMode.RoundedInside:
        return $localize`Внутренний радиус`;

      case AngleMode.Cutted:
        return $localize`Спил`;

      case AngleMode.DiagonalCut:
        return $localize`Диагональ`;

      case AngleMode.CuttedInside:
        return $localize`Г-образный вырез (90°)`;

      case AngleMode.CuttedInsideWithAngle:
        return $localize`Г-образный вырез угловой`;

      case AngleMode.Chamfer:
        return $localize`Фаска (45°)`;

      case AngleMode.MasonsMitreMale:
        return $localize`Еврозапил (скругленная фаска)`;

      case AngleMode.MasonsMitreFemale:
        return $localize`Еврозапил (выборка)`;

      default:
        return '';
    }
  }
}
